var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vector2i, Clone, FromJSON } from "js-vextensions";
import keycode from "keycode";
import { Column } from "react-vcomponents";
import { BaseComponent, BaseComponentPlus } from "react-vextensions";
import { VMenuLayer } from "react-vmenu";
import { WriteUI } from "UI/Write";
import { AddressBarWrapper, LoadURL, Observer, ErrorBoundary } from "vwebapp-framework";
import { observable, runInAction } from "mobx";
import { DragDropContext as DragDropContext_Beautiful } from "react-beautiful-dnd";
import ReactGA from "react-ga";
import { hasHotReloaded } from "Main";
import { AsyncTrunk } from "mobx-sync";
import { store } from "Store";
import { SetBookEventIndex } from "Server/Commands/SetBookEventIndex";
import "../../Source/Utils/Styles/Main.scss"; // keep absolute-ish, since scss file not copied to Source_JS folder
import { GetUserBackground, MeID } from "Store/firebase/users";
import { MessageBoxLayer } from "react-vmessagebox";
import { UIFocusEngine_OverlayUI } from "@Shared/UIFocusEngine_OverlayUI";
import { SetEventStepIndex } from "Server/Commands/SetEventStepIndex";
import { NavBar } from "../UI/@Shared/NavBar";
import { HomeUI } from "../UI/Home";
import { MoreUI } from "../UI/More";
import { UsersUI } from "./Users";
import { FeedbackUI } from "./Feedback";
let RootUIWrapper = class RootUIWrapper extends BaseComponent {
    constructor() {
        /*ComponentWillMount() {
            let startVal = g.storeRehydrated;
            // wrap storeRehydrated property, so we know when it's set (from CreateStore.ts callback)
            (g as Object)._AddGetterSetter("storeRehydrated",
                ()=>g.storeRehydrated_,
                val=> {
                    g.storeRehydrated_ = val;
                    setTimeout(()=>this.mounted && this.Update());//
                });
            // trigger setter right now (in case value is already true)
            g.storeRehydrated = startVal;
        }*/
        super(...arguments);
        // use observable field for this rather than react state, since setState synchronously triggers rendering -- which breaks loading process above, when rendering fails
        this.storeReady = false;
        this.OnDragEnd = result => {
            const sourceDroppableInfo = FromJSON(result.source.droppableId);
            const sourceIndex = result.source.index;
            const targetDroppableInfo = result.destination && FromJSON(result.destination.droppableId);
            let targetIndex = result.destination && result.destination.index;
            const draggableInfo = FromJSON(result.draggableId);
            if (targetDroppableInfo == null) {
            }
            else if (targetDroppableInfo.type == "UnorderedEventColumn") {
                new SetBookEventIndex({ characterID: sourceDroppableInfo.characterID, eventID: draggableInfo.eventID, index: null }).Run();
            }
            else if (targetDroppableInfo.type == "OrderedEventColumn") {
                // if we're moving an item to later in the same list, increment the target-index again (since react-beautiful-dnd pre-applies target-index adjustment, unlike the rest of our code that uses SetBookEventIndex/Array.Move())
                if (sourceDroppableInfo.type == targetDroppableInfo.type && sourceDroppableInfo.characterID == targetDroppableInfo.characterID && sourceIndex < targetIndex) {
                    targetIndex++;
                }
                new SetBookEventIndex({ characterID: sourceDroppableInfo.characterID, eventID: draggableInfo.eventID, index: targetIndex }).Run();
            }
            else if (targetDroppableInfo.type == "ActionsGrid") {
                // if something is focused, defocus it before running our action (so that it can apply its potential changes before we apply the reordering below)
                if (document.activeElement && document.activeElement["blur"]) {
                    document.activeElement["blur"]();
                }
                /*const event = GetEvent(targetDroppableInfo.eventID);
                const newSteps = CloneWithPrototypes(event.steps);
                newSteps.Move(newSteps[sourceIndex], targetIndex);
                new UpdateBookEvent({id: targetDroppableInfo.eventID, updates: {steps: newSteps}}).Run();*/
                new SetEventStepIndex({ eventID: targetDroppableInfo.eventID, sourceIndex, targetIndex }).Run();
            }
        };
    }
    async ComponentWillMount() {
        // InitStore();
        // temp fix for "Illegal invocation" error in mst-persist
        /* window.localStorage.getItem = window.localStorage.getItem.bind(window.localStorage);
        window.localStorage.setItem = window.localStorage.setItem.bind(window.localStorage);
        persist('some', store, {
            // jsonify: false,
            // whitelist: ['name']
            blacklist: [],
        }).then(() => {
            Log('Loaded state:', getSnapshot(store));
            this.SetState({ storeReady: true });
        }); */
        const trunk = new AsyncTrunk(store, { storage: localStorage });
        if (startURL.GetQueryVar("clearState") == "true") {
            await trunk.clear();
        }
        await trunk.init();
        Log("Loaded state:", Clone(store));
        if (!hasHotReloaded) {
            LoadURL(startURL);
        }
        // UpdateURL(false);
        if (PROD && store.main.analyticsEnabled) {
            Log("Initialized Google Analytics.");
            // ReactGA.initialize("UA-21256330-33", {debug: true});
            ReactGA.initialize("UA-21256330-33");
            /* let url = VURL.FromLocationObject(State().router).toString(false);
            ReactGA.set({page: url});
            ReactGA.pageview(url || "/"); */
        }
        // wrap with try, since it synchronously triggers rendering -- which breaks loading process below, when rendering fails
        /* try {
            this.SetState({ storeReady: true });
        } finally { */
        runInAction("RootUIWrapper.ComponentWillMount.notifyStoreReady", () => this.storeReady = true);
    }
    render() {
        // const { storeReady } = this.state;
        const { storeReady } = this;
        // if (!g.storeRehydrated) return <div/>;
        if (!storeReady)
            return null;
        return (React.createElement(DragDropContext_Beautiful, { onDragEnd: this.OnDragEnd },
            React.createElement(RootUI, null)));
    }
    ComponentDidMount() {
        /*if (devEnv) {
            WaitXThenRun(100, ()=> {
                G({Perf: React.addons.Perf});
                React.addons.Perf.start(); // this adds a new "User timings" section to the Profiler results, showing component render periods
            });
        }*/
        document.addEventListener("mousemove", event => {
            if (event["handledGlobally"])
                return;
            event["handledGlobally"] = true;
            g.mousePos = new Vector2i(event.pageX, event.pageY);
        });
        document.addEventListener("keydown", event => {
            if (event.which == keycode.codes.ctrl)
                g.ctrlDown = true;
            if (event.which == keycode.codes.shift)
                g.shiftDown = true;
            if (event.which == keycode.codes.alt)
                g.altDown = true;
        });
        document.addEventListener("keyup", event => {
            if (event.which == keycode.codes.ctrl)
                g.ctrlDown = false;
            if (event.which == keycode.codes.shift)
                g.shiftDown = false;
            if (event.which == keycode.codes.alt)
                g.altDown = false;
        });
        // if in dev-mode, disable the body's minHeight attribute
        if (DEV) {
            document.body.style.minHeight = null;
        }
    }
};
__decorate([
    observable
], RootUIWrapper.prototype, "storeReady", void 0);
RootUIWrapper = __decorate([
    Observer
], RootUIWrapper);
export { RootUIWrapper };
g.mousePos = new Vector2i(undefined, undefined);
G({ ctrlDown: false, shiftDown: false, altDown: false });
let RootUI = class RootUI extends BaseComponentPlus({}, {}) {
    /* shouldComponentUpdate(newProps, newState) {
        // ignore change of "router" prop -- we don't use it
        return ShallowChanged(newProps.Excluding("router"), this.props.Excluding("router")) || ShallowChanged(newState, this.state);
    } */
    render() {
        const { page } = store.main;
        const background = GetUserBackground(MeID());
        return (React.createElement(Column, { className: "background" /*"unselectable"*/, style: { height: "100%" } },
            React.createElement("style", null, `
				.background {
					background-color: ${background.color};
					background-image: url(${background.url_1920 || background.url_3840 || background.url_max});
					background-position: ${background.position || "center center"};
					background-size: ${background.size || "cover"};
				}
				@media (min-width: 1921px) {
					.background {
						background-image: url(${background.url_3840 || background.url_max});
					}
				}
				@media (min-width: 3841px) {
					.background {
						background-image: url(${background.url_max});
					}
				}
				`),
            React.createElement(ErrorBoundary, null,
                React.createElement(AddressBarWrapper, null),
                React.createElement(OverlayUI, null)),
            React.createElement(ErrorBoundary, null,
                React.createElement(NavBar, null)),
            React.createElement(ErrorBoundary, null,
                React.createElement("main", { style: { position: "relative", flex: 1, overflow: "hidden", display: "flex", justifyContent: "center", alignItems: "flex-start" } },
                    page == "users" && React.createElement(UsersUI, null),
                    page == "feedback" && React.createElement(FeedbackUI, null),
                    page == "more" && React.createElement(MoreUI, null),
                    page == "home" && React.createElement(HomeUI, null),
                    page == "write" && React.createElement(WriteUI, null)))));
    }
};
RootUI = __decorate([
    Observer
], RootUI);
class OverlayUI extends BaseComponent {
    render() {
        return (React.createElement("div", { style: { position: "absolute", top: 0, bottom: 0, left: 0, right: 0, overflow: "hidden" } },
            React.createElement(MessageBoxLayer, null),
            React.createElement(VMenuLayer, null),
            React.createElement(UIFocusEngine_OverlayUI, null)));
    }
}
